module.exports = __webpack_public_path__ + "5b28c053d7476d04a49a66645461745c.svg";